<script setup lang="ts">
definePageMeta({
    sidebar: false,
    hidePromotions: true,
})

const { site } = useCoreConfig()
const { data } = await useConsentData('privacy-policy-v2')

// SEO - START
const { getHead, getSeoMeta } = useStrapiSeo(
    {
        metaTitle: `Privatlivspolitik | ${site.name}`,
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// SEO - END
</script>

<template>
    <div class="privatlivspolitik">
        <div class="content">
            <NimbusStrapiBlockRenderer
                v-if="data?.content?.length"
                :content="data.content || []"
            />
            <p v-else>
                Der skete en fejl ved hentning af privatlivspolitikken. Prøv venligst igen om et øjeblik.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
:deep(.content) {
    p {
        strong:first-child {
            padding-right: 0.25rem;
        }
    }
}
</style>
